import React from 'react';
import {FieldsRendererProps} from '../FieldsRenderer';
import {Grid} from '@mui/material';
import {Stack} from '@mui/material';
import {AppControlledDateTimePicker} from 'components/form';

interface RenderDateTimePickerProps extends FieldsRendererProps {
    gridSize?: number;
}

export const RenderDateTimePicker: React.FC<RenderDateTimePickerProps> = ({
    control,
    field,
    gridSize,
    baseFieldName,
}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledDateTimePicker
                    label={field.title}
                    control={control}
                    defaultValue={null}
                    required={field.isRequired}
                    name={`${baseFieldName}.value`}
                />
            </Stack>
        </Grid>
    );
};

export default RenderDateTimePicker;
